import type { ReactNode } from 'react';
import { Frame, Navigation, TopBar } from '@shopify/polaris';

import { clearSession, getAdmin } from '@/auth/session';

export type Route = 'dashboard' | 'shops' | 'admins' | 'test-stores' | 'discounts' | 'profile';

const ITEMS: Array<{ id: Route; label: string }> = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'shops', label: 'Shops' },
  { id: 'discounts', label: 'Promo codes' },
  { id: 'test-stores', label: 'Test stores' },
  { id: 'admins', label: 'Admins' },
  { id: 'profile', label: 'Profile' },
];

/**
 * The ops chrome.
 *
 * ⚠ A real Polaris `Navigation`, not App Bridge's `NavMenu`. The ops dashboard
 * is never embedded in the Shopify admin — there is no host chrome to render
 * into, and `ui-nav-menu` outside an iframe is an undefined custom element that
 * silently renders nothing.
 */
export function Layout({
  route,
  onNavigate,
  onSignOut,
  children,
}: {
  route: Route;
  onNavigate: (r: Route) => void;
  onSignOut: () => void;
  children: ReactNode;
}) {
  const admin = getAdmin();

  return (
    <Frame
      topBar={
        <TopBar
          userMenu={
            <TopBar.UserMenu
              name={admin?.displayName || admin?.username || 'Ops'}
              initials={(admin?.username ?? 'O').slice(0, 1).toUpperCase()}
              open={false}
              onToggle={() => {}}
              actions={[
                {
                  items: [
                    {
                      content: 'Sign out',
                      onAction: () => {
                        clearSession();
                        onSignOut();
                      },
                    },
                  ],
                },
              ]}
            />
          }
        />
      }
      navigation={
        <Navigation location={route}>
          <Navigation.Section
            title="Confetto Ops"
            items={ITEMS.map((i) => ({
              label: i.label,
              url: i.id,
              selected: route === i.id,
              onClick: () => onNavigate(i.id),
            }))}
          />
        </Navigation>
      }
    >
      {children}
    </Frame>
  );
}
